<script>
  
import Button from '../shared/Button.svelte';
import {createEventDispatcher} from 'svelte';
let dispatch = createEventDispatcher();
let question = '';
let answerA = '';
let answerB = '';

let errors = { question: '', answerA: '', answerB: ''};
let valid = false;

const submitHandler = () => {
    valid = true;
    //validate question
    if (question.trim().length < 5 ) {
        errors.question = 'Question must be at least 5 characters long.';
        valid = false;
    } else {
        errors.question = '';
    }
    //validate answerA
    if (answerA.trim().length < 1) {
        errors.answerA = 'Answer A cannot be empty.';
        valid = false;
    } else {
        errors.answerA = '';
    }
    //validate answerB
    if (answerB.trim().length < 1) {
        errors.answerB = 'Answer B cannot be empty.';
        valid = false;
    } else {
        errors.answerB = '';
    }
    //Add new poll if valid
    if (valid) {
        const poll = { question, answerA, answerB, votesA: 0, votesB: 0, id: Math.random() };
        dispatch('add', poll);
        // reset form
        question = '';
        answerA = '';
        answerB = '';
    }
};
</script>

<form on:submit|preventDefault={submitHandler}>
    <div class="form-field">
        <label for="question">Poll Question:</label>
        <input type="text" id="question" name="question" bind:value={question} />
        <div class="error">{errors.question}</div>
    </div>

    <div class="form-field">
        <label for="answer-a">Answer A:</label>
        <input type="text" id="answer-a" name="answer-a" bind:value={answerA} />
        <div class="error">{errors.answerA}</div>
    </div>

    <div class="form-field">
        <label for="answer-b">Answer B:</label>
        <input type="text" id="answer-b" name="answer-b" bind:value={answerB} />
        <div class="error">{errors.answerB}</div>
    </div>
    <Button type="submit">Create Poll</Button>
</form>

<style>
form { 
    
   width: 400px;
    margin: 0 auto;
    text-align: center;
}
.form-field {
    
    margin: 18px auto;
}
input {
    
    border-radius: 6px;
    width: 100%;
}
label {
    margin: 10px auto;
    
    text-align: left;
}
.error {
    color: red;
    font-size: 0.875rem;
    height: 1.2rem;
    margin-top: 4px;
}
</style>